import {I18n} from 'react-i18nify';
import contentDefinitionTypes from '../../config/contentDefinitionTypes';

const initialState = {
    items: [],
    select: [],
    selectPages: [],
    selectBlocks: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GLOBALS':
            const select = [];
            const selectPages = [];
            const selectBlocks = [];

            action.payload.contentDefinitions.forEach((contentDefinition) => {
                if (contentDefinitionTypes[contentDefinition.contentDefinitionType].type === 'Block') {
                    selectBlocks.push({
                        id: contentDefinition.id,
                        title: I18n.t('block.' + contentDefinition.key)
                    });
                } else if (contentDefinitionTypes[contentDefinition.contentDefinitionType].type === 'Page') {
                    selectPages.push({
                        id: contentDefinition.id,
                        title: I18n.t('content.' + contentDefinition.key)
                    });
                }

                select.push({
                    id: contentDefinition.id,
                    title: contentDefinition.key
                });
            });

            return {
                ...state,
                items: action.payload.contentDefinitions,
                select: select,
                selectPages: selectPages,
                selectBlocks: selectBlocks
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/contentdefinition.js